var map = {
	"./dollar-icon.svg": "610d",
	"./footer/Facebook.svg": "39bb",
	"./footer/Instagram.svg": "e598",
	"./footer/Linkedin.svg": "ec92",
	"./footer/Twitter.svg": "e559",
	"./footer/X.svg": "19ea",
	"./footer/Xing.svg": "8fa7",
	"./footer/Youtube.svg": "df5f",
	"./footer/contact.svg": "9fe7",
	"./footer/pin.svg": "20af",
	"./footer/place.svg": "0309",
	"./handshake.svg": "9769",
	"./header/menu-close.svg": "cf5c",
	"./header/menu.svg": "f910",
	"./house-bray.svg": "3783",
	"./photo-bray.svg": "2792"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";